import { render, staticRenderFns } from "./TransactionVolume.vue?vue&type=template&id=804f7492"
import script from "./TransactionVolume.vue?vue&type=script&lang=js"
export * from "./TransactionVolume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('804f7492')) {
      api.createRecord('804f7492', component.options)
    } else {
      api.reload('804f7492', component.options)
    }
    module.hot.accept("./TransactionVolume.vue?vue&type=template&id=804f7492", function () {
      api.rerender('804f7492', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Activity/Conversion/TransactionVolume.vue"
export default component.exports